import { render, staticRenderFns } from "./PaymentAssignModal.vue?vue&type=template&id=20f2be72"
import script from "./PaymentAssignModal.vue?vue&type=script&lang=js"
export * from "./PaymentAssignModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports